<template>
    <div class="validation-documents">
        <v-alert border-color="primary" border="start" dense v-if="nb_inscrits_to_validate == 0">Il n'y a
            aucun coureur en attente de validation</v-alert>
        <div v-else>
            <v-alert border-color="primary" border="start" dense>
                Il y a <b>{{ nb_inscrits_to_validate }} coureur(s)</b> en attente de validation.
            </v-alert>
            <v-table>
                <thead>
                    <tr>
                        <th class="text-left">Nom - Prénom</th>
                        <th class="text-left">Date de naissance</th>
                        <th class="text-left">Course</th>
                        <th class="text-left">Date de course</th>
                        <th class="text-left">Consulter le document</th>
                        <th class="text-left">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="inscription in pendings_documents.list_inscriptions" :key="inscription.id">
                        <td>{{ inscription.nom }} {{ inscription.prenom }}</td>
                        <td>{{ $moment(inscription.date_naissance).format("DD/MM/YYYY") }}</td>
                        <td>{{ inscription.course.nom }} {{ get_discipline(inscription.course) }}</td>
                        <td>{{ get_date_course(inscription.course) }}</td>
                        <td>
                            <a :href="get_document_url(inscription)" target="_blank">
                                <v-btn class="text-decoration-underline" prepend-icon="mdi-file-eye-outline"
                                    density="compact" color="primary-dark" variant="text">{{
                                        inscription.champs.type_document }}</v-btn></a>
                        </td>
                        <td>
                            <v-btn class="mx-1" color="green-darken-4" @click="openDialogValidateDocument(inscription)"
                                density="compact">Valider</v-btn>
                            <v-btn class="mx-1" color="red-darken-4" @click="openDialogRejectDocument(inscription)"
                                density="compact">Refuser</v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-table>
            <v-dialog v-model="show_validate" width="500" max-width="100%" scroll-strategy="none">
                <v-card>
                    <v-card-text>
                        <div class="text-body-1">Voulez-vous vraiment <b>valider</b> le document de ce participant ?
                        </div>
                        <div>Il recevra un email l'informant que son inscription est désormais validée et complète.
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="red-darken-4" @click="show_validate = false">Non</v-btn>
                        <v-btn color="green-darken-4" @click="handle_validate">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_reject" width="500" max-width="100%" scroll-strategy="none">
                <v-card>
                    <v-card-text>
                        <div class="text-body-1">Voulez-vous vraiment <b>rejeter</b> ce participant ?</div>
                        <div>Il recevra un email l'informant que son document est refusé et sera inviter à se rendre
                            sur sa fiche coureur pour en charger un nouveau.</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="red-darken-4" @click="show_reject = false">Non</v-btn>
                        <v-btn color="green-darken-4" @click="handle_reject">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <!-- Add your component template here -->
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service.js";
export default {
    name: 'ValidationDocuments',
    data() {
        return {
            pendings_documents: {},
            inscription_to_validate: {},
            show_validate: false,
            show_reject: false,
            // Add your component data here
        };
    },
    methods: {

        openDialogValidateDocument(inscription) {
            this.inscription_to_validate = inscription;
            this.show_validate = true;
        },
        openDialogRejectDocument(inscription) {
            this.inscription_to_validate = inscription;
            this.show_reject = true;
        },
        async handle_reject() {
            this.show_reject = false;
            this.inscription_to_validate.status = "rejected";
            let request = await AdminService.validateDocument(this.inscription_to_validate);
            if (!request.error) {
                await this.fetch_list_documents();
            }
        },
        async handle_validate() {
            this.show_validate = false;
            this.inscription_to_validate.status = "accepted";
            let request = await AdminService.validateDocument(this.inscription_to_validate);
            if (!request.error) {
                await this.fetch_list_documents();
            }
        },
        async fetch_list_documents() {
            let request = await AdminService.getValidationDocumentsPendings(this.mainStore.module.id);
            if (!request.error) {
                this.pendings_documents = request;
            }
        },

        get_discipline(course) {
            let discipline = course.metadatas.find((m) => m.nom === "discipline");
            return discipline ? `(${discipline.valeur})` : "";
        },
        get_date_course(course) {
            return this.$moment(course.date_depart).format("DD/MM/YYYY");
        },
        get_document_url(inscription) {
            const type_document = inscription.champs.type_document;
            if (type_document === "Licence" || type_document === "Licence FFA" || type_document === "Licence FFTRI" || type_document === "Licence Experience") {
                return inscription.champs.licence_document;
            } else if (type_document === "Autre licence") {
                return inscription.champs.autre_licence_document;
            } else if (type_document === "Document PPS") {
                return inscription.champs.pps_document;
            }
            else if (type_document === "Licence FFCO") {
                return inscription.champs.licence_ffco_document;
            }
            else if (type_document === "Non licencié FFCO") {
                return inscription.champs.questionnaire_ffco_document;
            }

            else {
                return inscription.champs.cm_document ? inscription.champs.cm_document : "";
            }
        },
        // Add your component methods here
    },
    computed: {
        ...mapStores(useMainStore),
        nb_inscrits_to_validate() {
            if (!this.pendings_documents || !this.pendings_documents.list_inscriptions) return 0;
            return this.pendings_documents.list_inscriptions.length;
        },
        // Add your computed properties here
    },
    async mounted() {
        await this.fetch_list_documents();
        // Add your mounted logic here
    }
};
</script>

<style scoped></style>